import { combineReducers } from "redux"

import canvas from "./canvasReducer"
import config from "./configReducer"

export default combineReducers({
    canvas,
    config
})



// WEBPACK FOOTER //
// ./src/reducers/index.js